import voca from 'voca';

export function pluralizeProjectsName({
  count,
  currentActor,
  shouldCapitalize = false,
  shouldIncludeCount = false,
}) {
  const projectsName =
    currentActor.division.attributes[
      count === 1 ? 'singularRAMSName' : 'pluralRAMSName'
    ];

  return [
    shouldIncludeCount ? count.toLocaleString() : null,
    shouldCapitalize ? voca.capitalize(projectsName) : projectsName,
  ]
    .filter(Boolean)
    .join(' ');
}
